import { memo } from 'react'

type Props = {
  color: string
  children: React.ReactNode
}

const DotText = memo(({ color, children }: Props) => (
  <div className='flex items-center justify-start leading-4 [&_span]:ms-1 [&_span]:text-colorTextQuaternary'>
    <span className='me-[0.5em] rounded-full p-1' style={{ backgroundColor: color }} />
    {children}
  </div>
))

export default DotText
